/**
 * Pengaturan environment aktif di sisi frontend (production vs development/sandbox).
 *
 * Pilihan disimpan di localStorage dan dikirim ke backend lewat header `X-App-Env`
 * pada setiap request (lihat interceptor di services/jwtAuth.js). Backend (satu deployment)
 * merutekan koneksi DB ke production atau development berdasarkan header tersebut.
 * Bersifat per-client: pengguna lain tidak terpengaruh.
 */

const ENV_KEY = 'app_environment';
export const ENV_PRODUCTION = 'production';
export const ENV_DEVELOPMENT = 'development';

export const getEnvironment = () => localStorage.getItem(ENV_KEY) || ENV_PRODUCTION;

export const setEnvironment = (env) => {
    if (env === ENV_DEVELOPMENT) {
        localStorage.setItem(ENV_KEY, ENV_DEVELOPMENT);
    } else {
        localStorage.setItem(ENV_KEY, ENV_PRODUCTION);
    }
};

export const isDevelopment = () => getEnvironment() === ENV_DEVELOPMENT;
